import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, size, map, filter } from "lodash";

import Grid from "@material-ui/core/Grid";

import ProfileSearchInput from "../../Common/ProfileSearchInput";
import FormSection from "../../Common/FormSection";
import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const AddOccurrenceHostForm = (props) => {
  const { classes, formValues, handleChange, companies } = props;

  const siteZones = get(
    filter(
      get(
        filter(
          companies,
          (c) =>
            size(
              filter(
                get(c, ["sites"]),
                (s) => s.id === get(formValues, ["site"])
              )
            ) > 0
        ),
        [0, "sites"]
      ),
      (s) => s.id === get(formValues, ["site"])
    ),
    [0, "zones"]
  );

  return (
    <Grid container direction="column" className={classes.container}>
      <Grid item container className={classes.containerTitle}>
        <Grid item style={{ marginRight: "7px" }}>
          <img src={images.humanIconBlack} height="12px" alt="human" />
        </Grid>
        <Grid item>{I18n.get("scheduler_host")}</Grid>
      </Grid>
      <Grid item>
        <ProfileSearchInput
          profileType={1}
          id={"hostProfile"}
          selectProfile={(profile) => handleChange("host", null, profile)}
          selectedProfile={get(formValues, ["host"])}
          sizes={{
            input: 320,
            inputDropdown: 350,
            profile: 420,
          }}
          express
          minHeight={get(formValues, ["profile"]) ? null : 150}
          noMinHeight={get(formValues, ["profile"]) ? true : false}
          noLabel
          style={{ paddingTop: "22px", marginTop: "-6px" }}
          
          profileMatchProps={{
            backgroundColor: colors.white,
          }}
          disableNewProfile
          siteFilter={get(formValues, ["site"])}
        />
      </Grid>
      {get(formValues, ["host"]) && (
        <>
          <Grid item>
            <FormSection
              formValue={[get(formValues, ["zone"])]}
              setFormValue={handleChange}
              title="zone"
              id={"zone"}
              type="select"
              options={{
                required: true,
                redBorder: !get(formValues, ["zone"]),
                options: map(siteZones, (z) => ({
                  id: z.id,
                  name: z.name,
                })),
              }}
            />
          </Grid>
          <Grid item>
            <FormSection
              formValue={[get(formValues, ["comment"]) || ""]}
              setFormValue={handleChange}
              attribute={{ id: 19 }}
              id={"comment"}
              type="input"
              options={{
                multiline: true,
                rows: 5,
              }}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default AddOccurrenceHostForm;
